import React, { useState } from 'react';


export default function TextForm(props) {
    const handleUpClick = () => {
        // console.log('Button Clicked' + text);
        const newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Text convert to uppercase", "success");
    }

    const handleLowClick = () => {
        // console.log('Button Clicked' + text);
        const newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Text convert to lowercase", "info")
    }
    const handleCapClick = () => {
        const newText = text.replace(/\b\w/g, i => i.toUpperCase())
        setText(newText);
        props.showAlert("Text convert to capitalize", "success");
    }

    const handleDelClick = () => {
        // console.log('Button Clicked' + text);
        const newText = "";
        setText(newText);
        props.showAlert("Your text has been cleared", "danger")
    }

    const handleCopy = () => {
        // console.log('Button Clicked' + text);
        const text = document.getElementById('textBox');
        text.select();
        text.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(text.value);
        props.showAlert("Your text copy to your clipboard", "success")

    }

    const handleSpace = () => {

        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));


    }

    const handleOnChange = (event) => {
        // console.log('On Change');
        setText(event.target.value);
    }

    const [text, setText] = useState('Enter text here');
    return (
        <>
            <div className="container" style={{ color: props.theme === 'dark' ? 'white' : 'black' }}>
                <div className='d-flex justify-content-between'>
                    <h3 className='mt-4'>{props.heading}</h3>
                </div>
                <div className="my-3">
                    <textarea className="form-control" id="textBox" value={text} style={{ backgroundColor: props.theme === 'dark' ? '#18181b' : 'white', color: props.theme === 'dark' ? 'white' : 'black' }} onChange={handleOnChange} rows="8"></textarea>
                </div>
                <div className='d-flex flex-wrap gap-3 mt-3'>
                    <button className="btn btn-primary mx-1" onClick={handleUpClick}>Convert To Uppercase</button>
                    <button className="btn btn-primary mx-1" onClick={handleLowClick}>Convert To Lowercase</button>
                    <button className='btn btn-primary mx-1' onClick={handleDelClick}>Clear</button>
                    <button className="btn btn-primary mx-1" onClick={handleCapClick}>Convert To Capital</button>
                    <button className='btn btn-primary mx-1' onClick={handleCopy} id='copy'>Copy Text</button>
                    <button className="btn btn-primary mx-1" onClick={handleSpace}>Remove Extra Spaces</button>
                </div>
            </div>

            <div className='my-3 container fw-bold' style={{ color: props.theme === 'dark' ? 'white' : 'black' }}>
                <p>Your Word is {text.split(" ").length} and {text.length} characters</p>
                <p>{0.008 * text.split(" ").length} minute to read this article</p>
                <h3>Preview :</h3>
                <br />
                <p className=''>{text.length > 0 ? text : 'write something in the textbox avobe to preview it here...'}</p>
            </div>


        </>
    )
}
